module.exports = __webpack_public_path__ + "img/members-right-bsc2.335942d1.png";